import React from 'react';
import { Cell, Legend, Pie, PieChart } from 'recharts';
import Section from '../../../../components/outline/Section';
import CouponPreview from '../../common/CouponPreview';
import { COUPON_USAGE_RATE_CHART_COLORS } from '../../../../constants/service/app/couponConstants';
import './CouponDetailStatistics.scss';

const CouponDetailStatistics = (props) => {
  const { couponInfo, couponStatistics } = props;

  return (
    <div className="coupon-detail-statistics">
      {/*쿠폰 미리보기*/}
      <CouponPreview couponInfo={couponInfo} />

      {/*쿠폰 사용률*/}
      <Section className="coupon-usage-rate-section" title="쿠폰 사용률">
        {couponStatistics.issued ? (
          <PieChart width={400} height={350}>
            <Pie
              label
              data={couponStatistics.chartData}
              dataKey="value"
              nameKey="name"
              outerRadius={100}
              fill="#8884d8"
            >
              {couponStatistics.chartData.map((item, index) => (
                <Cell key={`cell-${index}`} fill={COUPON_USAGE_RATE_CHART_COLORS[item.key]} />
              ))}
            </Pie>
            <Legend height={36} />
          </PieChart>
        ) : (
          <div>발급된 쿠폰이 없습니다.</div>
        )}
      </Section>
    </div>
  );
};

export default CouponDetailStatistics;
